

export default {
  name: '404',
}
